import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { BookOpen } from "lucide-react";
import { API, BACKEND_URL } from "@/lib/api";
import SmartImage from "@/components/SmartImage";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API}/questions?limit=12`)
      .then(({ data }) => setItems(data.filter((d) => d.image_url)))
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section data-testid="gallery" className="border-t border-border/70 bg-muted/30">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <p className="mb-2 text-center font-sans text-xs uppercase tracking-[0.25em] text-primary">The Gallery</p>
        <h2 className="mb-8 text-center font-serif text-3xl tracking-tight text-foreground sm:text-4xl">
          Questions others have asked
        </h2>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {items.map((it, i) => (
            <motion.button
              key={it.id}
              data-testid="gallery-card"
              onClick={() => navigate(`/a/${it.id}`)}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 4) * 0.06 }}
              whileHover={{ y: -6 }}
              className="group relative flex aspect-[4/5] flex-col justify-end overflow-hidden rounded-md border border-border text-left shadow-sm transition-shadow hover:shadow-lg"
            >
              <SmartImage
                src={`${BACKEND_URL}${it.image_url}`}
                alt={it.title}
                className="absolute inset-0 h-full w-full"
                imgClassName="object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
              <div className="relative z-10 p-4">
                <BookOpen className="mb-2 h-4 w-4 text-white/70" />
                <p className="font-serif text-lg leading-tight tracking-tight text-white">{it.title}</p>
                <p className="mt-1 line-clamp-2 font-sans text-xs text-white/70">{it.question}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
